<div class="grid">
  <div class="col-12">
    <div class="flex justify-content-between align-items-center mb-3">
      <h2>Shift Summaries</h2>
      <div class="flex gap-2">
        <button pButton label="Back to Job" icon="pi pi-arrow-left" class="p-button-outlined" (click)="navigateBack()"></button>
        <button pButton label="New Shift Summary" icon="pi pi-plus" (click)="navigateToCreate()"></button>
      </div>
    </div>
  </div>

  <div class="col-12">
    <p-progressSpinner *ngIf="loading()"></p-progressSpinner>
    <p-table *ngIf="summaries$ | async as summaries" [value]="summaries" [paginator]="true" [rows]="10" [rowHover]="true"
      styleClass="p-datatable-sm" [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
      <ng-template #header>
        <tr>
          <th pSortableColumn="shiftStartUtc">Shift Start <p-sortIcon field="shiftStartUtc"></p-sortIcon></th>
          <th pSortableColumn="shiftEndUtc">Shift End <p-sortIcon field="shiftEndUtc"></p-sortIcon></th>
          <th>Day/Night</th>
          <th>Current Status</th>
          <th>Status</th>
          <th>Total Hours</th>
          <th>Created By</th>
          <th>Created</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template #body let-summary>
        <tr>
          <td>{{ summary.shiftStartUtc | date:'short' }}</td>
          <td>{{ summary.shiftEndUtc | date:'short' }}</td>
          <td>{{ summary.dayNight }}</td>
          <td>{{ summary.currentStatus }}</td>
          <td>{{ statusLabel(summary) }}</td>
          <td>{{ summary.totalHoursWorked | number:'1.2-2' }}</td>
          <td>{{ summary.createdBy }}</td>
          <td>{{ summary.created | date:'short' }}</td>
          <td class="flex gap-1">
            <button pButton icon="pi pi-eye" class="p-button-text p-button-sm" pTooltip="View" (click)="navigateToView(summary)"></button>
            <button
              pButton
              icon="pi pi-trash"
              class="p-button-text p-button-sm p-button-danger"
              pTooltip="Delete"
              [disabled]="deletingSummaryId() === summary.id || !canDelete(summary)"
              (click)="confirmDelete(summary)">
            </button>
          </td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td colspan="9" class="text-center">No shift summaries found for this job.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
